var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5933C13.5313 13.5933 15.5833 11.5413 15.5833 9.00997C15.5833 6.47866 13.5313 4.42664 11 4.42664C8.46865 4.42664 6.41663 6.47866 6.41663 9.00997C6.41663 11.5413 8.46865 13.5933 11 13.5933ZM11 13.5933C6.94987 13.5933 3.66663 16.0557 3.66663 19.0933M11 13.5933C15.05 13.5933 18.3333 16.0557 18.3333 19.0933",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/accountIcon.34055b6b0dcf02832dac4d753a0ff8f8.svg";
export { ForwardRef as ReactComponent };